import { LocalDate } from 'js-joda';

import * as Dashboard from 'types';
import { toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  endDate?: LocalDate;
  payouts: Dashboard.Payout[];
  requestInProgress: boolean;
  startDate?: LocalDate;
}

const initialState: State = {
  endDate: undefined,
  payouts: [],
  requestInProgress: false,
  startDate: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SET_PAYOUTS_REPORT_DATE_RANGE: {
      return {
        ...state,
        endDate: payload.endDate,
        startDate: payload.startDate,
      };
    }
    case AppConstants.FETCH_PAYOUTS_FOR_REPORT_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.FETCH_PAYOUTS_FOR_REPORT_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.FETCH_PAYOUTS_FOR_REPORT_DONE: {
      const payouts = toJSONArray<Dashboard.Payout>(payload);
      return {
        ...state,
        payouts,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
